export const article = [
  {
    articleId: 29,
    url: "cambiar-contrasena",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "Cambiar contraseña",
    content: 
      <>
        <div className="row">
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Ingresa a megago.cl, iniciar sesión y selecciona el link ¿Has olvidado tu contraseña?</li>
              <img src="https://images2-mega.cdn.mdstrm.com/ott/helpcenter/recover-1.jpg" className="articleImg" />
              <li>Ingresa tu correo y sigue las instrucciones.</li>
              <img src="https://images2-mega.cdn.mdstrm.com/ott/helpcenter/recover-2.jpg" className="articleImg" />
              <li>Ingresa tu nueva contraseña y confirma ingresándola nuevamente.</li>
              <img src="https://images2-mega.cdn.mdstrm.com/ott/helpcenter/recover-3.jpg" className="articleImg" />
              <li>Ya puedes ingresar a Mega GO con tu nueva contraseña.</li>
            </ul>
          </div>
        </div>
      </>
  }
];